export default __webpack_public_path__ + "static/media/arrow_copy_light.53a9ebfa.svg";